import { render, staticRenderFns } from "./LeadStatusForm.vue?vue&type=template&id=4ce008e6&scoped=true"
import script from "./LeadStatusForm.vue?vue&type=script&lang=js"
export * from "./LeadStatusForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce008e6",
  null
  
)

export default component.exports